import { h } from '../lib/dom.js';
import { getState } from '../store.js';
import { closeLanguagePicker, setLanguage } from '../actions.js';
import { t, supportedLanguages } from '../i18n/index.js';

export function renderLanguagePicker() {
  const s = getState();
  if (!s.showLanguagePicker) return null;

  const select = h('select', {
    onchange: (e) => { setLanguage(e.target.value); closeLanguagePicker(); }
  }, supportedLanguages().map((l) => h('option', { value: l.code, selected: l.code === s.language || undefined }, l.label)));

  return h('div', { class: 'modal-scrim' }, [
    h('div', { class: 'modal-card' }, [
      h('div', { class: 'modal-title' }, t('landing.chooseLanguage')),
      select,
      h('button', { class: 'btn btn-secondary text-muted', onclick: closeLanguagePicker }, t('common.close'))
    ])
  ]);
}
